import { graphql, HttpResponse } from 'msw'
import { type EnrollmentWelcomeData, type EnrollmentWelcomeSubmitOutput } from '../../../models'

export const getEnrollmentWelcomeDataMock: EnrollmentWelcomeData = {
  __typename: 'SubmitEnrollmentSuccess',
}

export const submitEnrollmentWelcomeDataMock: EnrollmentWelcomeSubmitOutput = {
  __typename: 'SubmitEnrollmentSuccess',
  path: '/enrollment/investments/BROKERAGE/welcome',
}

export const mockGetEnrollmentWelcomeData = graphql.mutation('getEnrollmentWelcomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: getEnrollmentWelcomeDataMock } })
})

export const mockSubmitEnrollmentWelcomeData = graphql.mutation('submitEnrollmentWelcomeData', () => {
  return HttpResponse.json({ data: { submitEnrollment: submitEnrollmentWelcomeDataMock } })
})

export const mockEnrollmentWelcome = [mockGetEnrollmentWelcomeData, mockSubmitEnrollmentWelcomeData]
